<template>
  <div class="v-card cart sticky">
    <table class="fancy" :data-cart-id="cart.id">
      <thead>
        <tr>
          <th class="left-align">Order Summary</th>
          <th class="right-align">Qty</th>
          <th class="right-align">Total</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="cartLoaded" v-for="(item, index) in cart.cart_items">
          <cart-item :cart-item="item" :index="index"></cart-item>
        </template>
        <tr v-if="cartLoaded && hasCartItems">
          <td class="mx-0 px-0 semibold" colspan=3>
            <table class="plain" width='100%'>
              <tr>
                <td class="right-align">Order Subtotal</td>
                <td class="right-align" width=1>{{itemsSubtotal | currency}}</td>
              </tr>
              <tr>
                <td class="right-align">Shipping &amp; Processing</td>
                <td class="right-align" width=1>{{totalShipping | currency | doubleDashForZero}}</td>
              </tr>
              <tr>
                <td class="right-align">Sales Tax</td>
                <td class="right-align" width=1>{{cart.total_tax | currency | doubleDashForZero}}</td>
              </tr>
              <tr>
                <td class="right-align">Order Total</td>
                <td class="right-align" width=1>{{total_price | currency}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <template v-else="true">
          <tr>
            <td class="center-align" colspan=3>
              No Items in your cart.
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <v-btn block color="primary" :disabled="!hasCartItems" v-if="!inCheckout" to="/checkout">Check Out</v-btn>
  </div>
</template>

<script>
  import CartItem from './cart-item'

  export default {
    components: {
      cartItem: CartItem
    },

    beforeMount () {
      this.$store.dispatch('loadCart')
    },

    filters: {
      doubleDashForZero: function (str) {
        if (str === '$0.00') return '--'
        else return str
      }
    },

    computed: {
      cart: {
        get () {
          return this.$store.state.cart
        },
        set (value) {
          this.$store.commit('saveCart', value)
        }
      },

      inCheckout () {
        return this.$route.path.indexOf('checkout') > -1
      },

      cartLoaded () {
        if (!this.cart || !this.cart.cart_items) return true
        return this.cart && this.cart.cart_items
      },

      hasCartItems () {
        if (!this.cart || !this.cart.cart_items) {
          return false
        }

        return this.cart.cart_items.length > 0
      },

      itemsSubtotal () {
        if (!this.cart.cart_items) return false

        var subtotal = 0
        this.cart.cart_items.forEach(
          (item) => {
            subtotal += this.unitPrice(item.quantity, item.unit_prices)
          }
        )
        return subtotal
      },

      totalShipping () {
        if (!this.hasCartItems) {
          return 0
        }

        return this.cart.total_shipping
      },

      total_price () {
        return parseFloat(this.itemsSubtotal) +
               parseFloat(this.cart.total_shipping) +
               parseFloat(this.cart.total_tax)
      }
    },

    methods: {
      unitPrice (quantity, prices) {
        if (quantity >= 250) return prices[250] * quantity
        else if (quantity >= 100) return prices[100] * quantity
        else if (quantity >= 5) return prices[5] * quantity
        else return prices[1] * quantity
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?799a4e8c